/**
 * Pick suggested prompt bubbles for the focused OS app (profile-driven).
 */

import { personalizeSamplePromptTemplates } from "@/services/inAppAgent/samplePromptPlaceholders";

export function resolveInAppAgentSamplePrompts(
  focusedApp: string,
  homePrompts: string[] | undefined,
  appSamplePrompts: Record<string, string[]> | undefined,
  householdName?: string | null,
): string[] {
  const appId = focusedApp.trim();
  const templates =
    appId && appSamplePrompts?.[appId]?.length
      ? appSamplePrompts[appId].filter((row) => typeof row === "string" && row.trim().length > 0)
      : (homePrompts ?? []).filter((row) => typeof row === "string" && row.trim().length > 0);

  return personalizeSamplePromptTemplates(templates, householdName);
}
